import { AiAgent } from './aiAgentsConsts';
import { useSelector } from 'react-redux';
import { selectDefaultCreationCrmOrgId } from '../../reducers/userInfoReducer';
import useObjectTypesWithFetch from '../../hooks/useObjectTypesWithFetch';
import IssuesCard from '../issues/IssuesCard';

const AgentIssues = ({ agent }: { agent: AiAgent }) => {
  const crmOrgId = useSelector(selectDefaultCreationCrmOrgId);
  const { objectTypesByName } = useObjectTypesWithFetch({ crmOrgId: crmOrgId ?? '' });

  const objectType =
    'objectType' in agent.contextComponents ? agent.contextComponents.objectType : undefined;
  const objectLabel = objectType ? (objectTypesByName[objectType]?.label ?? objectType) : '';

  return (
    <IssuesCard
      issues={agent.issues}
      objectLabel={objectLabel}
      isLoading={!!agent.isLoadingIssues}
      activeScan={agent.activeScan}
    />
  );
};

export default AgentIssues;
